import Http from './http'

export const get = (aliasQuery) => Http.get(`/clients/${aliasQuery}`)

export default {
  get
}